<template>
  <app-loading-section class="tab-loading-section" :loading="isLoading">
    <div class="team_section--user columns is-multiline m-0">
      <div class="team_stat_box column is-3"
        v-for="user in users"
        :key="user.id"
      >
        <div class="team_stat_box--sections">
          <div class="team_stat_box--section">
            <div class="team_stat_box--section--avatar">
              <app-avatar :user-id="user.id" :display-tool-tip="false"></app-avatar>
            </div>
            <h4 class="team_stat_box--section--heading">{{ user.name }}</h4>
          </div>

          <div class="team_stat_box--section">
            <stats-team-users-stat label="Calls Made" icon="call" :number="user.calls_made"/>

            <stats-team-users-stat label="SMS Sent" icon="sms" :number="user.sms_sent"/>

            <stats-team-users-stat label="Email Sent" icon="email" :number="user.email_sent"/>

            <stats-team-users-stat label="Inbound Addressed" icon="addressed" :number="user.inbound_addressed"/>
          </div>

          <div class="team_stat_box--section">
            <stats-team-users-stat label="Assigned Tasks" icon="campaign-mls" :number="user.assigned_tasks"/>

            <stats-team-users-stat label="Total Completed Tasks" icon="checkbox" :number="user.total_completed_tasks" color="is-success"/>

            <stats-team-users-stat label="Task Completed Late" icon="checkbox-blank" :number="user.task_completed_late" color="is-success"/>

            <stats-team-users-stat label="Total Incomplete Tasks" icon="checkbox" :number="user.total_incomplete_tasks" color="is-danger"/>

            <stats-team-users-stat label="Incomplete and Past Due Tasks" icon="checkbox-blank" :number="user.incomplete_past_due_tasks" color="is-danger"/>
          </div>

          <div class="team_stat_box--section">
            <stats-team-users-stat label="Assigned Leads" icon="assigned_leads" :number="user.assigned_leads"/>

            <stats-team-users-stat label="Appointments Set" icon="appointments" :number="user.appointments_set"/>

            <stats-team-users-stat label="Appointments Assigned" icon="appointment_assigned" :number="user.appointments_assigned"/>

            <stats-team-users-stat label="Appointments Cancelled By Us" icon="past-due" :number="user.appointments_cancelled"/>
          </div>
        </div>
      </div>
    </div>
  </app-loading-section>
</template>

<script>
import StatsTeamUsersStat from "./StatsTeamUsersStat.vue";

export default {
  name: "StatsTeamUsers",
  components: {StatsTeamUsersStat},
  data() {
    return {
      isLoading: true,
      users: []
    }
  },
  watch: {
    'activeTab' () {
      if (this.activeTab === 'StatsTeamUsers') {
        this.loadStats()
      }
    }
  },
  computed: {
    activeTab() {
      return this.$store.getters['statsTeam/getActiveTab']
    },
    statFilter() {
      return this.$store.getters['statsTeam/getFilters']
    },
  },
  methods: {
    loadStats() {
      // TODO api call
      this.isLoading = true
      const filter = {
        start_at: this.statFilter.timeFrameValues.start,
        end_at: this.statFilter.timeFrameValues.end,
        users: this.statFilter.users
      }

      setTimeout(() => {
        console.log('Setup StatsTeamUsers')
        this.users = this.$store.getters.activeUsers.map(user => {
          return {
            id: user.id,
            name: user.full_name,
            calls_made: Math.floor(Math.random() * 20) + 1,
            sms_sent: Math.floor(Math.random() * 20) + 1,
            email_sent: Math.floor(Math.random() * 20) + 1,
            inbound_addressed: Math.floor(Math.random() * 20) + 1,
            assigned_tasks: Math.floor(Math.random() * 20) + 1,
            total_completed_tasks: Math.floor(Math.random() * 20) + 1,
            task_completed_late: Math.floor(Math.random() * 20) + 1,
            total_incomplete_tasks: Math.floor(Math.random() * 20) + 1,
            incomplete_past_due_tasks: Math.floor(Math.random() * 20) + 1,
            assigned_leads: Math.floor(Math.random() * 20) + 1,
            appointments_set: Math.floor(Math.random() * 20) + 1,
            appointments_assigned: Math.floor(Math.random() * 20) + 1,
            appointments_cancelled: Math.floor(Math.random() * 20) + 1,
          }
        })

        this.isLoading = false
        return true
      }, 1000)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../styles/variables/variables";

.team_section {
  min-height: 150px;

  &--user {
    align-items: stretch;
  }
}

.team_stat_box {
  position: relative;
  margin-right: 1rem;
  margin-bottom: 1rem;
  padding: 12px;
  border: 1px solid $border;

  &:nth-child(3n), &:last-child {
    margin-right: 0;
  }

  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  @media (min-width: 1215px) {
    width: 31.5%;
  }

  &--section {
    display: flex;
    justify-content: center;
    margin-bottom: 17px;

    &:first-child {
      flex-wrap: wrap;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &--avatar {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 6px;
    }

    &--heading {
      width: 100%;
      font-size: 15px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
